import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const NomineeBanner = () => {
  const ColorButton2 = styled(Button)(() => ({
    color: "#fff",
    width: 250,
    height: 65,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "#D7A036",
    borderColor: "#D7A036",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#049593",
      borderColor: "#049593",
    },
  }));

  return (
    <Box marginTop={{ xs: "35%", sm: "12%" }}>
      <Box width={"100%"}>
        <Typography
          variant="h2"
          color="#D7A036"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
          display={{ xs: "none", sm: "inline" }}
        >
          <Typography
            component={"span"}
            color="#049593"
            fontWeight={800}
            variant={"h2"}
          >
            2022 {""}
          </Typography>
          Shortlisted Nominees
        </Typography>
        <Typography
          variant="h3"
          color="#D7A036"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
          display={{ xs: "inline", sm: "none" }}
        >
          <Typography
            component={"span"}
            color="#049593"
            fontWeight={800}
            variant={"h3"}
          >
            2022 {""}
          </Typography>
          Shortlisted Nominees
        </Typography>
      </Box>
      <Box
        padding={{ xs: "8% 2% 1% 0%", sm: "2% 2% 1% 0%" }}
        width={"100%"}
        display={"flex"}
        justifyContent={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "2%", sm: "0%" }}
        >
          <ColorButton2
            component={"a"}
            variant="outlined"
            size="medium"
            href={"/2022-aca-winners"}
          >
            Meet 2022 ACA Winners
          </ColorButton2>
        </Box>
      </Box>
    </Box>
  );
};

export default NomineeBanner;
